// src/mixins/colorMixin.js
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    // Vuex 'report_list' 모듈에서 selected_report와 selected_lv1 상태를 가져옵니다.
    // this.selected_report 와 this.selected_lv1 으로 접근 가능하게 됩니다.
    ...mapGetters('report_list', ['selected_report', ]),
    ...mapGetters('story_board', ['selected_lv1']),

    /**
     * 조건에 따라 동적으로 메인 색상을 반환하는 계산된 속성입니다.
     * @returns {string | null} 계산된 메인 색상 코드. 의존하는 상태가 없으면 null 반환.
     */
    main_color() {
      // selected_lv1 객체가 유효한지 먼저 확인합니다.
      if (!this.selected_lv1 || !this.selected_report) {
        return null; // 또는 기본 fallback 색상 '#000000'
      }

      const colorMap = {
        "pufoa250911_ad3600d7724f": "#30B085",
        "pufoa250911_18f32caece5d": "#BD7850",
        "pufoa250911_12637cd618ee": "#A6AFEF",
      };

      // this.selected_lv1.key 값에 따라 색상을 반환하고, 없으면 기본값을 사용합니다.
      return colorMap[this.selected_lv1.key] ?? this.selected_report.main_color;
    },

    /**
     * 조건에 따라 동적으로 서브 색상을 반환하는 계산된 속성입니다.
     * @returns {string | null} 계산된 서브 색상 코드. 의존하는 상태가 없으면 null 반환.
     */
    sub_color() {
      if (!this.selected_lv1 || !this.selected_report) {
        return null;
      }
      
      const colorMap = {
        "pufoa250911_ad3600d7724f": "#72C086",
        "pufoa250911_18f32caece5d": "#F4A875",
        "pufoa250911_12637cd618ee": "#B2B9DD",
      };

      return colorMap[this.selected_lv1.key] ?? this.selected_report.sub_color;
    },
  },
};